'use client'

import Features from '@/components/landing/features';
import Footer from '@/components/landing/footer';
import Hero from '@/components/landing/hero';
import Navbar from '@/components/landing/navbar';
import Pricing from '@/components/landing/pricing';
import Widget from '@/components/landing/widget';
import LandingPageLayout from '@/components/layouts/landing-page-layout';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

export default function Home() {
      const t = useTranslations('index');

      useEffect(() => {
            // Smooth scroll function for anchor links
            const handleAnchorClick = (e: MouseEvent) => {
                  const target = e.target as HTMLElement;
                  const href = target.closest('a')?.getAttribute('href');

                  if (href?.startsWith('#') && href.length > 1) {
                        e.preventDefault();
                        const element = document.getElementById(href.substring(1));
                        if (element) {
                              element.scrollIntoView({
                                    behavior: 'smooth'
                              });
                        }
                  }
            };

            document.addEventListener('click', handleAnchorClick);

            return () => {
                  document.removeEventListener('click', handleAnchorClick);
            };
      }, []);

      return (<LandingPageLayout>
            <Navbar />
            <main>
                  <Hero />
                  <Features />
                  <Widget />
                  <Pricing />
            </main>
            <Footer />
      </LandingPageLayout>
            // <BackgroundPageLayout className='flex flex-col items-center justify-center'>
            //       <h1 className='text-4xl font-bold'>{t('title')}</h1>
            //       <Image src="/logo/logo_light.png" alt="Kiwilog" width={800} height={300} />
            //       <span className='text-xl'>{t('description')}</span>


            // </BackgroundPageLayout>
            // <main className="flex min-h-screen flex-col items-center justify-between p-24 dark:bg-gray-900 dark:text-white">
            //       <h1>{t('title')}</h1>
            //       <p>{t('description')}</p>
            //       <div className="flex gap-4 items-center">
            //             <LanguageSwitcher />
            //             <ThemeSwitcher />
            //       </div>
            // </main>
      );
} 